module.exports = __webpack_public_path__ + "static/media/26UNRWA21.fa3ae54d.jpg";